import { logger } from '../../utils/logger';
import { DispositionData } from './types';
import { formatPhoneForSAP, resolveSapCtiContactId } from './phone.util';
import { buildEndDispositionXml, escapeXml } from './cti-xml.util';
import { postToSapHost } from '../sap-context/cti-origin.util';

function buildOutboundDispositionXml(disposition?: DispositionData): string {
  const subject = disposition ? `Outbound Call: ${disposition.dispositionName}` : 'Outbound Call';

  if (!disposition) {
    return `
  <Subject>Outbound Call</Subject>`;
  }

  return `
  <Subject>${escapeXml(subject)}</Subject>
  <Text>${escapeXml(disposition.notes || '')}</Text>
  <Custom_1>${escapeXml(disposition.dispositionCode)}</Custom_1>
  <Custom_2>${escapeXml(disposition.dispositionName)}</Custom_2>`;
}

export function sendSapEnd(
  phone: string,
  contactId: string,
  referenceId: string,
  disposition?: DispositionData,
  displayId?: string
): void {
  const formattedPhone = formatPhoneForSAP(phone);
  const ctiContactId = resolveSapCtiContactId(contactId, displayId);
  const { dispositionXml } = buildEndDispositionXml(disposition);

  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<payload>
  <Type>CALL</Type>
  <EventType>UPDATEACTIVITY</EventType>
  <Action>END</Action>
  <ANI>${formattedPhone}</ANI>
  <CustomerID>${escapeXml(ctiContactId)}</CustomerID>
  <ContactID>${escapeXml(ctiContactId)}</ContactID>${dispositionXml}
  <ExternalReferenceID>${referenceId}</ExternalReferenceID>
</payload>`;

  logger.debug(
    '[SAP CTI] Sending END for contact:',
    ctiContactId,
    'disposition:',
    disposition?.dispositionName || 'none',
    'refId:',
    referenceId
  );
  postToSapHost(xml);
}

export function sendSapOutboundEnd(
  phone: string,
  contactId: string,
  referenceId: string,
  disposition?: DispositionData,
  displayId?: string
): void {
  const formattedPhone = formatPhoneForSAP(phone);
  const ctiContactId = resolveSapCtiContactId(contactId, displayId);
  const dispositionXml = buildOutboundDispositionXml(disposition);

  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<payload>
  <Type>CALL</Type>
  <EventType>UPDATEACTIVITY</EventType>
  <Action>END</Action>
  <ANI>${formattedPhone}</ANI>
  <CustomerID>${escapeXml(ctiContactId)}</CustomerID>
  <ContactID>${escapeXml(ctiContactId)}</ContactID>${dispositionXml}
  <ExternalReferenceID>${referenceId}</ExternalReferenceID>
</payload>`;

  logger.debug(
    '[SAP CTI] Sending OUTBOUND END for contact:',
    ctiContactId,
    'disposition:',
    disposition?.dispositionName || 'none',
    'refId:',
    referenceId
  );
  postToSapHost(xml);
}
